import {
    type FC,
    useContext,
    useEffect,
    useState,
} from "react";
import { Select, type SelectOptionType } from "@onshopfront/components";
import { determineDataSource } from "../../../../Data/DataStores/DataSource";
import { DragDropEditorContext, type DragDropSettingsProps } from "../../../Forms/DragDrop/DragDropTypes";
import { isTaxIndicatorValue } from "../ReceiptTaxIndicatorComponent";

export const ReceiptTaxIndicatorSettings: FC<DragDropSettingsProps> = ({
    id,
    value,
}) => {
    const { manager } = useContext(DragDropEditorContext);

    const [ selected, setSelected ] = useState<SelectOptionType<string> | null>(null);
    const [ taxRates, setTaxRates ] = useState<Array<SelectOptionType<string>>>([]);
    const [ loading, setLoading ] = useState(true);

    useEffect(() => {
        if(!isTaxIndicatorValue(value)) {
            return;
        }

        setLoading(true);

        determineDataSource()
            .then(source => source.taxRates.all())
            .then(taxRates => {
                const options = [{
                    label: "No Tax",
                    value: "",
                }];

                let selected: SelectOptionType<string> | null = null;

                for(const taxRate of taxRates) {
                    const option = {
                        label: taxRate.name,
                        value: taxRate.uuid,
                    };

                    options.push(option);

                    if(taxRate.uuid === value.tax) {
                        selected = option;
                    }
                }

                if(selected === null) {
                    selected = options[0];
                }

                setSelected(selected as SelectOptionType<string>);
                setLoading(false);
                setTaxRates(options);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let indicator = "*";
    let text = "indicates items with";

    if(isTaxIndicatorValue(value)) {
        indicator = value.indicator;
        text = value.text;
    }

    return (
        <>
            <label className="block">
                Indicator
                <input
                    type="text"
                    value={indicator}
                    onChange={e => {
                        manager.updateComponent(id, {
                            ...(isTaxIndicatorValue(value) ? value : {}),
                            indicator: e.currentTarget.value,
                        });
                    }}
                    placeholder="*"
                />
            </label>
            <label className="block">
                Text
                <input
                    type="text"
                    value={text}
                    onChange={e => {
                        manager.updateComponent(id, {
                            ...(isTaxIndicatorValue(value) ? value : {}),
                            text: e.currentTarget.value,
                        });
                    }}
                    placeholder="Indicates items with"
                />
            </label>
            <label className="block">
                Tax
                <Select
                    placeholder="Select a tax..."
                    loading={loading}
                    options={taxRates}
                    value={selected}
                    onChange={(option: SelectOptionType<string>) => {
                        setSelected(option);
                        manager.updateComponent(id, {
                            ...(isTaxIndicatorValue(value) ? value : {}),
                            tax: option.value,
                        });
                    }}
                />
            </label>
        </>
    );
};
